"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const Party_vue_1 = require("@/client/components/Party.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectParty',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedParty: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        Party: Party_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selectedParty === undefined) {
                return;
            }
            this.onsave({ type: 'party', partyName: this.selectedParty });
        },
        isDominant(partyName) {
            return partyName === this.turmoil?.dominant;
        },
        partyAvailableToSelect(partyName) {
            if (this.playerinput.parties === undefined) {
                return false;
            }
            else {
                return this.playerinput.parties.includes(partyName);
            }
        },
    },
    computed: {
        turmoil() {
            return this.playerView.game.turmoil;
        },
    },
});
